import AppShortcutIcon from "@mui/icons-material/AppShortcut";
import type { ReactNode } from "react";
import { ValueTile } from "Components/Shared/ValueTile/ValueTile";

type Props = {
  isLoading: boolean;
  value: string;
  title: string;
  explanationHint: ReactNode;
};

export const MyShareValue = ({
  isLoading,
  value,
  title,
  explanationHint,
}: Props) => (
  <ValueTile
    isLoading={isLoading}
    icon={<AppShortcutIcon />}
    title={title}
    value={value}
    variant="basic"
    explanationHint={explanationHint}
  />
);
